import { parkingMonitoringGroupsSagas } from './groups';
import { parkingMonitoringPositionsSagas } from './positions';
import { parkingMonitoringZonesSagas } from './zones';

export default [
  ...parkingMonitoringGroupsSagas,
  ...parkingMonitoringPositionsSagas,
  ...parkingMonitoringZonesSagas,
];
